import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

/** API */

/** COMPONENT */
import { Box, Grid } from '@mui/material';
import PersonnelApi from 'api/setting/personnel-managements/personnel.api';
import ImportInventoryApi from 'api/warehouses/import-inventory.api';
import { resetModal } from 'app/slice/modal.slice';
import { notiError, notiSuccess } from 'component/notifications/notifications';
import TextAreaInput from 'new-components/inputs/text-area-input';
import TextInput from 'new-components/inputs/text-input';
import PageModal from 'new-components/modal/page-modal';

type PopupCancelImportType = {
    inventoryDocumentId: number,
    document: { prefix: string, documentNo: string }
    onCancel: (show: boolean) => void
    onAfterSubmit: (show: boolean) => void
}

const initStateErrorMessage = {
    username: '',
    password: '',
    cancelRemark: ''
}

export default function PopupCancelImport(props: PopupCancelImportType) {
    const dispatch = useDispatch()
    const { t } = useTranslation()
    const [inputs, setInputs]: any = useState({})
    const [errorMessage, setErrorMessage] = useState(initStateErrorMessage)

    const handleChange = (key: any, event: any) => {
        const name = key
        const value = event.target.value
        setInputs((values: any) => ({ ...values, [name]: value }))
        setErrorMessage(initStateErrorMessage)
    }

    const onSubmitCancel = async () => {
        if (!inputs.username || !inputs.password || !inputs.cancelRemark) {
            return setErrorMessage({
                username: !inputs.username ? t('IMPORT_PRODUCT.MESSAGE.USER_NAME') : '',
                password: !inputs.password ? t('IMPORT_PRODUCT.MESSAGE.PASSWORD') : '',
                cancelRemark: !inputs.cancelRemark ? t('IMPORT_PRODUCT.MESSAGE.REASON') : ''
            })
        }

        PersonnelApi.findPermissions({ username: inputs.username, password: inputs.password })
            .then(({ data }) => {
                if (data.hasCancelVisit === 'PERMISS') {
                    ImportInventoryApi.cancel(props.inventoryDocumentId, { cancelBy: inputs.username, cancelRemark: inputs.cancelRemark })
                        .then(({ data }) => {
                            notiSuccess(t('IMPORT_PRODUCT.MESSAGE.CANCEL_SUCCESS'))
                            dispatch(resetModal())
                            props.onAfterSubmit && props.onAfterSubmit(false)
                        })
                        .catch((e) => {
                            const message = e?.response?.data?.message
                            if (message === 'SOME_ITEMS_HAVE_ALREADY_BEEN_USED') notiError(t('IMPORT_PRODUCT.MESSAGE.SOME_ITEMS_HAVE_ALREADY_BEEN_USED'))
                            else notiError(t('IMPORT_PRODUCT.MESSAGE.CANNOT_CANCEL'))
                        })
                } else return setErrorMessage({ ...errorMessage, ...{ username: t('IMPORT_PRODUCT.MESSAGE.PERMISSION_NOT_FOUND') } })
            })
            .catch((e) => {
                const status = e?.response?.status
                setErrorMessage({ ...errorMessage, ...{ username: status === 404 ? t('INPUT.NOT_FOUND_USER_NAME') : '', password: status === 400 ? t('INPUT.PASSWORD_INCORRECT') : '' } })
            })
    }

    return (
        <PageModal
            size={'S'}
            title={t('IMPORT_PRODUCT.POPUP.HEADER')}
            isOpen
            overflow
            handleClose={() => {
                props.onCancel && props.onCancel(false)
                setInputs({})
            }}
            onSubmit={{ onClick: () => onSubmitCancel(), title: t('IMPORT_PRODUCT.BUTTON.CONFIRM'), type: 'danger' }}
            onCancel={{
                onClick: () => {
                    props.onCancel && props.onCancel(false)
                    setInputs({})
                }, title: t('IMPORT_PRODUCT.BUTTON.CANCEL')
            }}
        >
            <Grid container spacing={2}>
                <Grid item className={`w-100`}>
                    {t(`IMPORT_PRODUCT.POPUP.TITLE`,
                        { name: ((props.document.prefix && props.document.documentNo) && `${props.document.prefix}-${props.document.documentNo}`) || props.document.documentNo || '-' }
                    )}
                </Grid>
                <Grid item md={6} className={`w-100`}>
                    <TextInput
                        key="username"
                        onChange={(e) => handleChange("username", e)}
                        name="username"
                        value={inputs.username}
                        label={t('IMPORT_PRODUCT.POPUP.USER_NAME')}
                        helperText={errorMessage?.username}
                        required
                        fullWidth
                    />
                </Grid>
                <Grid item md={6} className={`w-100`}>
                    <TextInput
                        key="password"
                        onChange={(e) => handleChange("password", e)}
                        name="password"
                        value={inputs.password}
                        type="password"
                        helperText={errorMessage?.password}
                        label={t('IMPORT_PRODUCT.POPUP.PASSWORD')}
                        required
                        fullWidth
                    />
                </Grid>
                <Grid item className={`w-100`}>
                    <TextAreaInput
                        key="cancelRemark"
                        helperText={errorMessage?.cancelRemark}
                        required
                        label={t('IMPORT_PRODUCT.POPUP.REASON')}
                        value={inputs.cancelRemark}
                        onChange={(e) => handleChange("cancelRemark", e)}
                        fullWidth
                        maxLength={250}
                        inputProps={{
                            style: {
                                display: 'flex',
                                justifyContent: 'flex-end',
                                alignItems: 'flex-start',
                                fontSize: "12px"
                            },
                            startAdornment: (
                                <Box sx={{ position: "absolute", bottom: "2px" }}>
                                    <Box sx={{ fontSize: '12px', color: '#808080' }}>{`${inputs?.cancelRemark?.length || 0}/250`}</Box>
                                </Box>
                            ),
                        }}
                    />
                </Grid>
            </Grid>
        </PageModal>
    )
}
